import { Component, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { RuleInterface } from '@vendasta/automata/lib';
import { CommonTriggerPanelComponent } from '../../../common/common-trigger-panel.component';
import { TriggerBaseRules } from '../../../common/decorators/trigger-rules.decorator';
import { NoRules } from '../../common';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { TriggerService } from '../../../../trigger.service';

@Component({
  selector: 'automata-api-trigger-order-panel',
  templateUrl: './api-trigger-order-panel.component.html',
  styleUrls: ['./api-trigger-order-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyPipesModule,
  ],
})
export class ApiTriggerOrderPanelComponent extends CommonTriggerPanelComponent implements OnInit {
  automationId: string = this.triggerService.automationId;

  constructor(protected readonly triggerService: TriggerService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.savingEnabled$.next(true);
  }

  fillRuleValues(rules: RuleInterface[]): RuleInterface[] {
    return rules;
  }

  @TriggerBaseRules
  getBaseRules(): RuleInterface[] {
    return NoRules();
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [];
  }

  isFormValid(): boolean {
    return true;
  }
}
